import React from "react";

import {StringArgEditor} from "../string";
import {ModelSelectInputEditor} from "../model_select";
import {llmModels} from "modules/flowmaster/constants/models";

import {OrganisationId} from "common/types/organisation";
import {
  WorkflowTask,
  ActionDefinition,
} from "common/flowmaster/types/task_config";
import {ChildDataLocation} from "common/flowmaster/types/data_location";
import {
  WorkflowContext,
  WorkflowInputs,
  WorkflowInput,
  Prompt,
} from "common/flowmaster/types/workflow";
import Checkbox from "@material-ui/core/Checkbox";
import ContainedTextField from "../../contained_text_field";
import FormControlLabel from "@material-ui/core/FormControlLabel";

interface InputValueEditorProps {
  input: WorkflowInput;
  value: ChildDataLocation<string>;
  priorTasks: WorkflowTask[];
  context: WorkflowContext;
  inputs: WorkflowInputs;
  prompts: Prompt[];
  actionDefinitions: ActionDefinition[];
  onUpdateItem: (value: ChildDataLocation<string>) => void;
  organisationId: OrganisationId;
  useListItem: boolean;
  disabled?: boolean;
}

const InputValueEditor: React.FC<InputValueEditorProps> = ({
  input,
  value,
  priorTasks,
  context,
  inputs,
  prompts,
  actionDefinitions,
  onUpdateItem,
  organisationId,
  useListItem,
  disabled,
}) => {
  return (
    <div
      style={{
        display: "flex",
        border: "1px solid",
        padding: "1em",
        margin: "1em 0",
      }}
    >
      {input.name}
      {input.type === "llm_model" ? (
        <ModelSelectInputEditor
          argDefinition={{
            key: "model",
            label: "Model",
            options: llmModels,
            type: "model_select",
          }}
          argValue={{value} ?? {}}
          onUpdateItem={value =>
            onUpdateItem(value.value as ChildDataLocation<string>)
          }
          inputs={inputs}
          disabled={disabled}
        />
      ) : (
        <StringArgEditor
          argValue={{value} ?? {}}
          priorTasks={priorTasks}
          context={context}
          inputs={inputs}
          prompts={prompts}
          actionDefinitions={actionDefinitions}
          onUpdateItem={value =>
            onUpdateItem(value.value as ChildDataLocation<string>)
          }
          organisationId={organisationId}
          useListItem={useListItem}
          disabled={disabled}
        />
      )}
      <FormControlLabel
        value="top"
        control={
          <Checkbox
            checked={value?.add_to_links ?? false}
            onChange={e =>
              onUpdateItem({...value, add_to_links: e.target.checked})
            }
          />
        }
        label="Run Id"
        labelPlacement="end"
      />

      {value?.add_to_links && (
        <div>
          <ContainedTextField
            inputPropsStyle={{width: "10em"}}
            initialValue={value.link_key ?? ""}
            label="Key"
            onUpdate={linkKey => onUpdateItem({...value, link_key: linkKey})}
          />
        </div>
      )}
    </div>
  );
};

export default InputValueEditor;
